<div class="flex flex-col gap-10 my-4">
  <div class="flex flex-col gap-4">
    <span class="text-2xl font-semibold">3. Base legal</span>
    <span>Añade la normativa general que regula este servicio y especifica el tiempo de vigencia de la adhesión</span>
    <span class="text-sm text-neutral-base">Todos los campos marcados con (*) son obligatorios</span>
  </div>
  <span class="text-md font-bold -mb-4">Codigo de la normativa</span>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()">
    <div class="flex items-start gap-4 min-w-[1200px] w-full">
      <div class="flex flex-col flex-1 min-w-0 gap-3">
        <desy-select
          id="type"
          name="type"
          classes="w-full"
          [items]="normativeOptions"
          formControlName="type">
          <desy-label>Tipo*</desy-label>
        </desy-select>
        <desy-error-message *ngIf="form.get('type')?.touched && form.get('type')?.invalid">
          <span *ngIf="form.get('type')?.hasError('required')">Este campo es obligatorio</span>
        </desy-error-message>
      </div>
      <div class="flex gap-4 shrink-0">
        <div class="flex flex-col gap-2">
          <label for="range">Rango/Año *</label>
          <p-inputmask
            aria-describedby="range-help"
            formControlName="range"
            id="range"
            mask="99/9999"
            inputStyleClass="mi-input"
            placeholder="99/9999" />
          <small id="range-help">Ej. 28/2025</small>
        </div>

        <div class="flex flex-col gap-2 self-start">
          <label for="date">Fecha *</label>
          <p-datepicker
            formControlName="date"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputStyleClass="mi-input"
            inputId="icondisplay"></p-datepicker>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-md">Titulo de la normativa *</span>
      <div class="flex items-center gap-2">
        <span>Incluye el título de la normativa sin escribir su rango ni su fecha</span>
        <app-tooltip
          class="mb-[5px]"
          [title]="''"
          [tipeIcon]="'info'"
          [description]="'Incluye el título de la normativa sin escribir su rango ni su fecha'"></app-tooltip>
      </div>
      <desy-textarea
        formControlName="title"
        placeholder="Ej. General de subvenciones..."
        classes="w-full"
        class="w-full"
        [rows]="5">
        <desy-error-message *ngIf="form.get('title')?.touched && form.get('title')?.invalid">
          <span *ngIf="form.get('title')?.hasError('required')">Este campo es obligatorio</span>
        </desy-error-message>
      </desy-textarea>
      <!-- <div class="flex flex-wrap items-center gap-4">
        <span class="text-md">Titulo de la normativa *</span>
        <app-tooltip
          [title]="''"
          [tipeIcon]="'info'"
          [description]="'Incluye el título de la normativa sin escribir su rango ni su fecha'"></app-tooltip>
      </div>
      <textarea
        pTextarea
        style="background-color: white"
        formControlName="title"
        rows="5"
        cols="30"></textarea>
      <div
        *ngIf="form.get('title')?.touched && form.get('title')?.invalid"
        class="error text-sm text-alert-base">
        Título obligatorio
      </div> -->
    </div>

    <div class="flex flex-col gap-2 w-full">
      <label for="url">Enlace de la normativa *</label>
      <desy-input
        classes="w-full"
        class="w-full"
        placeholder="Ej. https://www.boe.es/pdf/2003/BOE-A2003-20977-consolidado.pdf"
        formControlName="url">
        <desy-error-message *ngIf="form.get('url')?.touched && form.get('url')?.invalid">
          <span *ngIf="form.get('url')?.hasError('required')">Este campo es obligatorio</span>
          <span *ngIf="form.get('url')?.hasError('pattern') && !form.get('url')?.hasError('required')">
            Enlace incorrecto. Debe ser un enlace válido (Ej. https://www.ejemplo.com). No se permiten el carácter "#"
          </span>
        </desy-error-message>
      </desy-input>
      <!--       <input
        pInputText
        id="url"
        type="text"
        formControlName="url" />
      <div
        class="error text-sm text-alert-base"
        *ngIf="form.get('url')?.touched && form.get('url')?.invalid">
        {{
          form.get('url')?.hasError('required')
            ? 'Enlace obligatorio'
            : 'Enlace incorrecto. Debe ser un enlace válido (Ej. https://www.ejemplo.com)'
        }}
      </div> -->
      <br />
    </div>

    <div class="flex flex-col gap-4">
      <span class="font-semibold">Tiempo de vigencia de la adhesión al protocolo de consulta *</span>

      <desy-radios
        formControlName="infinityDate"
        name="infinity-date"
        idPrefix="vigencia">
        <desy-radio-item [value]="true">
          <desy-label>Indefinida</desy-label>
          <desy-content>
            <span
              class="text-md text-neutral-base font-semibold mt-2 block"
              *ngIf="form.get('infinityDate')?.value === true">
              La adhesión no tendrá fecha de caducidad
            </span>
          </desy-content>
        </desy-radio-item>

        <desy-radio-item
          [value]="false"
          [conditional]="true">
          <desy-label>Seleccionar fecha</desy-label>
          <desy-content>
            <div class="mt-2">
              <p-datepicker
                formControlName="effectiveDate"
                class="w-[25%]"
                dateFormat="dd/mm/yy"
                [iconDisplay]="'input'"
                [inline]="true"
                [showIcon]="true"
                inputStyleClass="mi-input"
                placeholder="Selecciona una fecha"></p-datepicker>
            </div>
          </desy-content>
        </desy-radio-item>
      </desy-radios>

      <div class="flex gap-2">
        <app-buttons
          type="submit"
          [label]="'Guardar cambios'"></app-buttons>
      </div>
    </div>
  </form>
</div>
